export const BASE_URL = import.meta.env.BASE_URL || '';
export const MODE = import.meta.env.MODE;
export const IS_PROD = import.meta.env.PROD || false;
export const IS_STAGING = import.meta.env.VITE_STAGING === 'true' || false;
export const IS_DEV = import.meta.env.DEV || false;

export const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || "";
export const WEBRTC_HTTP_URL = import.meta.env.VITE_WEBRTC_HTTP_URL || "https://api-staging.gameglass.gg/graphql";
export const WEBRTC_WEBSOCKET_URL = import.meta.env.VITE_WEBRTC_WEBSOCKET_URL || "wss://api-staging.gameglass.gg/graphql";
export const WEBRTC_TOKEN_URL = import.meta.env.VITE_WEBRTC_TOKEN_URL || "https://api-staging.gameglass.gg/config/webrtc";
export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;
export const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';
export const NODE_ENV = import.meta.env.VITE_GG_NODE_ENV || 'development';
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'info';
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || '0.0.0';
export const FORGE_URL = import.meta.env.VITE_FORGE_URL || 'https://test-frontend.gameglass.gg/forge/staging';
export const API_URL = import.meta.env.VITE_API_URL || 'https://api-staging.gameglass.gg/api/1';

